import React, {useRef,useImperativeHandle, useState, useEffect } from 'react';
import UOMSlider from './UOMSlider';
import { useDispatch, useSelector } from 'react-redux';
import { getPsvDetails } from '../../actions/products';

export default React.forwardRef((props,ref) => {
	let sliderRef = useRef({});
	const storeProductUnderEdit = useSelector(
		state => state.products.editProduct
	);
	const productUnderEdit = props.productUnderEdit || storeProductUnderEdit;
	const [showSlider,showHideSlider] = useState(false) 
	const [psvUOM,setPsvUOM] = useState(null);
	const dispatch = useDispatch();
	const openCloseUOMSlider = flag => {
		showHideSlider(flag);
	};
	const closeUOMSliderOnBack = () => {
		openCloseUOMSlider(false);
		//updateUOMSlider(null);
	};

	useEffect(() => {
		if(showSlider && productUnderEdit && !psvUOM) {
			const psvData = dispatch(getPsvDetails({psv_node_id: productUnderEdit.psv_node_id || productUnderEdit.leafId,type: productUnderEdit.categoryType || productUnderEdit.type	}));
			if(psvData) {
				setPsvUOM(psvData.UNIT);
			}
		}
	},[showSlider])
	useImperativeHandle(ref, () => ({
		openCloseUOMSlider,
		closeUOMSliderOnBack
	}));
	if(!showSlider){
		if(!props.isMobile){
			props.onUomSliderClose && props.onUomSliderClose();
		}
		return true;
	}
	return (
		<UOMSlider
			ref={sliderRef}
			uomType={props.uomType}
			pageType = {props.isAddProduct?'add':'edit'}
			onSelectUOM={props.onSelectUOM}
			showUOMType={props.showUOMType}
			showHideSlider={showHideSlider}
			isHideStds={props.isHideStds}
			priceModal={props.priceModal}
			isProduct={props.isProduct}
			fromAddEditProduct={props.fromAddEditProduct}
			fromAddPrice={props.fromAddPrice}
			fromAddPricePriceRange={props.fromAddPricePriceRange}
			psvUOM={psvUOM}
		/>
	)
})
